import { IInitPaymentExtraData } from '../../../../repositories/billing-accounts/entities/CloudPayments/InitPaymentExtraData';
import { ICloudPaymentsWidgetData } from '../../../../types/cloudPayments';

export const mapData = (data: IInitPaymentExtraData | undefined): ICloudPaymentsWidgetData => {
  if (!data?.insertedClient) {
    return { insertedClient: null };
  }

  return {
    insertedClient: data.insertedClient,
  };
};
